<template>
  <v-container id="ao-container" class="pt-0">
    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>
    <v-row>
      <v-col lg="12" md="12" sm="12" class="pt-0">
        <CertificationsTable
          :headers="pendingCertificationsHeaders"
          :items="pendingCertifications"
          :title="'Certification Requests'"
          :isLoading="isPendingCertificationsLoading"
          v-on:approveCertifications="onApproveCertifications()"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingLearnersTable
          :headers="pendingLearnersHeaders"
          :items="unduplicatedLearners"
          :title="'Learner Registration Requests'"
          :isLoading="isPendingLearnersLoading"
          v-on:approveLearners="onApproveLearners()"

        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingCentresTable
          :headers="pendingCentreHeaders"
          :items="pendingCentres"
          :title="'Centre Registration Requests'"
          :isLoading="isPendingCentresLoading"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingQualificationsTable
          :headers="pendingQualificationsHeaders"
          :items="pendingQualifications"
          :title="'Qualification Registration Requests'"
          :isLoading="isPendingQualificationsLoading"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingUnitsTable
          :headers="pendingUnitsHeaders"
          :items="pendingUnits"
          :title="'Unit Registration Requests'"
          :isLoading="isPendingUnitsLoading"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PendingUnitsTable from "./PendingUnitsTable";
import PendingQualificationsTable from "./PendingQualificationsTable";
import PendingLearnersTable from "./PendingLearnersTable";
import CertificationsTable from "./CertificationsTable";
import PendingCentresTable from "./PendingCentresTable";

export default {
  mounted: function () {
    this.getPendingUnits();
    this.getPendingQualifications();
    this.getPendingLearners();
    this.getPendingCertifications();
    this.getPendingCentres();
  },
  components: {
    PendingUnitsTable,
    PendingQualificationsTable,
    PendingLearnersTable,
    CertificationsTable,
    PendingCentresTable,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      isPendingUnitsLoading: true,
      isPendingQualificationsLoading: true,
      isPendingLearnersLoading: true,
      isPendingCertificationsLoading: true,
      isPendingCentresLoading: true,
      pendingUnits: [],
      pendingQualifications: [],
      pendingLearners: [],
      pendingCertifications: [],
      pendingCentres: [],
      pendingUnitsHeaders: [
        {
          text: "Centre",
          align: "start",
          value: "centreName",
        },
        { text: "Unit Name", value: "unitName" },
      ],
      pendingQualificationsHeaders: [
        {
          text: "Centre",
          align: "start",
          value: "centreName",
        },
        { text: "Qualification", value: "qualificationName" },
      ],
      pendingLearnersHeaders: [
        {
          text: "Centre",
          align: "start",
          value: "centreName",
        },
        { text: "Learner", value: "learnerName" },
        { text: "Qualification", value: "qualificationName" },
        { text: "Application Number", value: "applicationNumber" },
        { text: "Request Date", value: "createdAt" },
      ],
      pendingCertificationsHeaders: [
        {
          text: "Centre",
          align: "start",
          value: "centreName",
        },
        { text: "Learner", value: "learnerName" },
        { text: "Qualification", value: "qualificationName" },
        { text: "Status", value: "status" },
        { text: "Request Date", value: "createdAt" },
      ],
      pendingCentreHeaders: [
        {
          text: "Code",
          align: "start",
          value: "code",
        },
        { text: "Name", value: "name" },
        { text: "City", value: "city" },
        { text: this.$t("centre.status"), value: "status" },
      ],
    };
  },
  watch: {
    isPendingUnitsLoading: function (newValue) {
      this.isPendingUnitsLoading = newValue;
    },
    isPendingQualificationsLoading: function (newValue) {
      this.isPendingQualificationsLoading = newValue;
    },
    isPendingLearnersLoading: function (newValue) {
      this.isPendingLearnersLoading = newValue;
    },
    isPendingCertificationsLoading: function (newValue) {
      this.isPendingCertificationsLoading = newValue;
    },
    isPendingCentresLoading: function (newValue) {
      this.isPendingCentresLoading = newValue;
    },
  },
  computed: {
    unduplicatedLearners: function () {
      const learnerList = [];

      for (let i = 0; i < this.pendingLearners.length; i++) {
        let duplicate = false;
        for (let j = 0; j < learnerList.length; j++) {
          if (this.pendingLearners[i].code == learnerList[j].code) {
            duplicate = true;
            break;
          }
        }

        if (!duplicate) {
          learnerList.push(this.pendingLearners[i]);
        }
      }

      learnerList.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      return learnerList;
    },
  },
  methods: {
    onApproveCertifications: function () {
      this.getPendingCertifications();
      this.snackbarText = "Certifications approved";
      this.snackbar = true;
    },
    onApproveLearners: function () {
      this.getPendingLearners();
      this.snackbarText = "Learners approved";
      this.snackbar = true;
    },
    getPendingUnits: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/units/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingUnitsLoading = false;
          this.pendingUnits = data.pendingUnits;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingQualifications: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/qualifications/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingQualificationsLoading = false;
          this.pendingQualifications = data.pendingQualifications;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingLearners: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/learners/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingLearnersLoading = false;
          this.pendingLearners = data.pendingLearners;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingCertifications: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/certifications/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingCertificationsLoading = false;
          this.pendingCertifications = data.certifications;

          if (this.$store.state.role == "ao") {
            this.pendingCertifications = this.pendingCertifications.map(
              (cert) => {
                if (cert.status == "moderation") {
                  cert.status = "Waiting for centre to upload assessment";
                } else if (cert.status == "submitted") {
                  cert.status = "Centre uploaded assessments";
                }
                return cert;
              }
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingCentres: async function () {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/centres?status=pending`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.isPendingCentresLoading = false;
        this.pendingCentres = data.centres;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
#ao-container {
  min-height: 100vh;
}
</style>